import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg"
};
export function render(_ctx, _cache) {
    return _openBlock(), _createElementBlock("svg", _hoisted_1, [
        ..._cache[0] || (_cache[0] = [
            _createElementVNode("path", {
                d: "M554.666667 426.666667h213.333333l-256 256-256-256h213.333333V128h85.333334v298.666667z m-384 384h682.666666v-298.666667h85.333334v341.333333a42.666667 42.666667 0 0 1-42.666667 42.666667H128a42.666667 42.666667 0 0 1-42.666667-42.666667v-341.333333h85.333334v298.666667z",
                "p-id": "26056"
            }, null, -1)
        ])
    ]);
}
